import React from "react";
import { EditDeploymentFreeze } from "./EditDeploymentFreeze";
export function CreateDeploymentFreezePage() {
    return <EditDeploymentFreeze create={true}/>;
}
